// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__kqdhu","boxTitle":"Qualiphy_boxTitle__2pjQH","box":"Qualiphy_box__1pdaT","toggleWrap":"Qualiphy_toggleWrap__2TdOy"};